/* eslint-disable react-hooks/exhaustive-deps */
import { CloseOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import pluralize from "pluralize";
import React from "react";
import QuestionAnswersList from "./questionAnswersList";

const QuestionAnswersModal = ({
  question,
  isOpen = false,
  close = () => {},
  users,
  onlyWithCommentDefaultValue = false,
  isAnonymous = false,
  refreshAnswers = () => {},
  defaultOpen,
}) => {
  const text = question?.text;
  const answers = question?.results?.answers ?? [];
  const answerCount = answers.length;

  return (
    <Modal
      width={650}
      onCancel={() => close()}
      open={isOpen}
      title={`${text} (${answerCount} ${pluralize("answer", answerCount)})`}
      footer={[
        <Button
          key="close"
          icon={<CloseOutlined />}
          type="primary"
          block
          onClick={() => close()}
        >
          Close
        </Button>,
      ]}
    >
      <QuestionAnswersList
        question={question}
        users={users}
        isAnonymous={isAnonymous}
        onlyWithCommentDefaultValue={onlyWithCommentDefaultValue}
        defaultOpen={defaultOpen}
        refreshAnswers={refreshAnswers}
        showFilters={true}
        showClarifications={true}
        isModalOpen={isOpen}
      />
    </Modal>
  );
};

export default QuestionAnswersModal;
